import JerseyColorSelector from './JerseyColorSelector';

export default JerseyColorSelector;
